// extracted by mini-css-extract-plugin
module.exports = {"Colocations":"styles_Colocations__1zD1p","coloUl":"styles_coloUl__3DvG-","colomap":"styles_colomap__kxhI0"};